import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...appConfig.providers,
    {
      provide: 'customServiceWorker',
      useFactory: () => {
        if ('serviceWorker' in navigator && window.location.protocol === 'https:') {
          navigator.serviceWorker.register('/assets/sw-custom.js')
            .then(reg => console.log('Custom SW registered', reg))
            .catch(err => console.error('Custom SW failed', err));
        }
      }
    }
  ]
}).catch((err) => console.error(err));
